<div class="form-file-input-container" [class]="'state-' + state" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" class="overflow-handler">
    <mat-icon *ngIf="state !== 'uploading'">{{ icon }}</mat-icon>
    <div *ngIf="state === 'uploading'">
      <mat-spinner [diameter]="24" color="info"></mat-spinner>
    </div>
    <button
      *ngIf="!value"
      type="button"
      mat-raised-button
      [disabled]="disabled || forcedDisabled"
      (blur)="onBlur()"
      waiFilePicker
      (waiFilePickerFileChange)="onInput($event)"
      [waiFilePickerAccept]="accept"
      [waiFilePickerDisabled]="disabled"
    >
      {{ 'INTL_UPLOAD' | translate }}
    </button>
    <ng-container *ngIf="value">
      <button
        mat-stroked-button
        class="mat-button-shortened unset"
        *ngIf="canOpen(value)"
        [matTooltip]="'INTL_DOWNLOAD' | translate"
        (click)="onFileOpen(value)"
      >
        <span class="text-wrapper">{{ value.name }}</span>
        <span>({{ value.fileSize | fileSize }})</span>
      </button>
      <div *ngIf="!canOpen(value)" class="file-label">{{ value.name }} ({{ value.fileSize | fileSize }})</div>
    </ng-container>
  </div>

  <div *ngIf="state !== 'empty'">
    <div *ngIf="state === 'deleting'" fxLayout="row" fxLayoutAlign="space-between center">
      <button *ngIf="counter > 0" class="inner-button" mat-stroked-button type="button" [disabled]="true">
        <mat-icon>cancel</mat-icon> {{ 'INTL_DELETE' | translate }} ({{ counter }})
      </button>

      <button
        *ngIf="counter <= 0"
        class="inner-button"
        color="primary"
        mat-raised-button
        type="button"
        (click)="onConfirmDelete()"
      >
        <mat-icon>cancel</mat-icon> {{ 'INTL_DELETE' | translate }}
      </button>

      <button mat-icon-button type="button" [matTooltip]="'INTL_CANCEL' | translate" (click)="onCancelDelete()">
        <mat-icon class="color-secondary-text">block</mat-icon>
      </button>
    </div>

    <button
      *ngIf="state !== 'deleting' && state !== 'uploading' && !disabled"
      mat-icon-button
      type="button"
      [matTooltip]="'INTL_DELETE' | translate"
      (click)="onDelete()"
    >
      <mat-icon class="color-secondary-text">close</mat-icon>
    </button>
  </div>
</div>
